import {
  OFFER_CATALOG_SAVE,
  OFFER_CATALOG_FAILURE,
  OFFER_CATALOG_FETCH,
  OFFER_CATALOG_RESET,
  OFFER_SUBSCRIPTION_REQUEST,
  OFFER_SUBSCRIPTION_SUCCESS,
  OFFER_SUBSCRIPTION_FAILURE,
  OFFER_SUBSCRIPTION_RESET,
} from "../constants/actionTypes";
import offerCatalogStatuses from "../enum/offerCatalogStatuses";
import offerSubscriptionStatuses from "../enum/offerSubscriptionStatuses";

const INITIAL_SUBSCRIPTION_STATE = {
  status: offerSubscriptionStatuses.IDLE,
  offerId: "",
  productType: "",
  error: null,
};

const INITIAL_STATE = {
  status: offerCatalogStatuses.IDLE,
  catalog: [],
  error: null,
  subscription: INITIAL_SUBSCRIPTION_STATE,
};

const applyFetchOfferCatalog = state => ({
  ...state,
  status: offerCatalogStatuses.LOADING,
});

const applySaveOfferCatalog = (state, action) => {
  const { catalog } = action.payload;
  return { ...state, status: offerCatalogStatuses.SUCCESS, catalog, error: null };
};

const applySaveOfferCatalogFailure = (state, action) => ({
  ...state,
  status: offerCatalogStatuses.FAILURE,
  error: action.payload.error,
});

const applyRequestOfferSubscription = (state, action) => {
  const { offerId, productType } = action.payload;
  return {
    ...state,
    subscription: {
      status: offerSubscriptionStatuses.SUBMITTING,
      offerId,
      productType,
      error: null,
    },
  };
};

const applySaveOfferSubscriptionSuccess = (state, action) => {
  const { offerId, productType } = action.payload;
  return {
    ...state,
    subscription: {
      status: offerSubscriptionStatuses.SUCCESS,
      offerId,
      productType,
      error: null,
    },
  };
};

const applySaveOfferSubscriptionFailure = (state, action) => {
  const { offerId, productType, error } = action.payload;
  return {
    ...state,
    subscription: {
      status: offerSubscriptionStatuses.FAILURE,
      offerId,
      productType,
      error,
    },
  };
};

const offerCatalogReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OFFER_CATALOG_FETCH:
      return applyFetchOfferCatalog(state);
    case OFFER_CATALOG_SAVE:
      return applySaveOfferCatalog(state, action);
    case OFFER_CATALOG_FAILURE:
      return applySaveOfferCatalogFailure(state, action);
    case OFFER_CATALOG_RESET:
      return INITIAL_STATE;
    case OFFER_SUBSCRIPTION_REQUEST:
      return applyRequestOfferSubscription(state, action);
    case OFFER_SUBSCRIPTION_SUCCESS:
      return applySaveOfferSubscriptionSuccess(state, action);
    case OFFER_SUBSCRIPTION_FAILURE:
      return applySaveOfferSubscriptionFailure(state, action);
    case OFFER_SUBSCRIPTION_RESET:
      return { ...state, subscription: INITIAL_SUBSCRIPTION_STATE };
    default:
      return state;
  }
};

export default offerCatalogReducer;
